import { render, staticRenderFns } from "./EditingDFInputText.vue?vue&type=template&id=48b5807d&"
import script from "./EditingDFInputText.vue?vue&type=script&lang=js&"
export * from "./EditingDFInputText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports